import { SwapPageFooterContinueButton } from '../../SwapPageFooter/SwapPageFooterContinueButton';
import React, { useState } from 'react';
import { InstantSwapFlowModalButtonTypes, InstantSwapFlowModalContentTypes } from './InstantSwapFlowModalTypes';
import { InstantSwapConfirmationModalContentFeature } from '../InstantSwapConfirmationModalContent';
import { InstantSwapModalSuccess } from '../InstantSwapModalSuccess';
import { InstantSwapModalError } from '../InstantSwapModalError';
import { useNavigate, useSearchParams } from '../../../hooks';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
export function useInstantSwapFlowModal(_a) {
    var initialModalContent = _a.initialModalContent, siteSwapConfiguration = _a.siteSwapConfiguration, swapFromScheduleDay = _a.swapFromScheduleDay, allScheduleDaysForDay = _a.allScheduleDaysForDay, selectedInstantSwap = _a.selectedInstantSwap, employeeId = _a.employeeId;
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var fromPath = searchParams.get('source');
    var handleOnClose = function () {
        // If user is on native, then go back to the native schedule page
        // This code is no longer needed once Swap page has been converted to a native app
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var atozmobile = window.atozmobile;
        // this fromPath.includes is needed because for some reason,
        // non-hq webview users cannot go back to the dashboard page
        // using popToTop()
        if (atozmobile && fromPath.includes(Routes.MySchedule)) {
            atozmobile.appNavigation.popToTop();
            return;
        }
        else {
            var indexRoute = swapFromScheduleDay.date
                ? "".concat(Routes.Index, "?date=").concat(swapFromScheduleDay.date)
                : Routes.Index;
            navigate(indexRoute);
            window.location.reload();
        }
    };
    var _b = useState(null), modalError = _b[0], setModalError = _b[1];
    var _c = useState(initialModalContent), modalContent = _c[0], setModalContent = _c[1];
    var modalButtonMap = function (open) {
        var _a;
        return (_a = {},
            _a[InstantSwapFlowModalButtonTypes.continue] = (React.createElement(SwapPageFooterContinueButton, { buttonId: "instantSwapConfirmation", onClick: function () {
                    setModalContent(InstantSwapFlowModalContentTypes.confirmation);
                    open();
                } })),
            _a);
    };
    var modalContentMap = function (close) {
        var _a;
        return (_a = {},
            _a[InstantSwapFlowModalContentTypes.confirmation] = (React.createElement(InstantSwapConfirmationModalContentFeature, { close: close, setModalContent: setModalContent, setModalError: setModalError, siteSwapConfiguration: siteSwapConfiguration, swapFromScheduleDay: swapFromScheduleDay, allScheduleDaysForDay: allScheduleDaysForDay, selectedInstantSwap: selectedInstantSwap, employeeId: employeeId })),
            _a[InstantSwapFlowModalContentTypes.instantSwapSuccess] = (React.createElement(InstantSwapModalSuccess, { allScheduleDaysForDay: allScheduleDaysForDay, newShift: selectedInstantSwap, siteId: siteSwapConfiguration.siteId, close: handleOnClose })),
            _a[InstantSwapFlowModalContentTypes.instantSwapError] = (React.createElement(InstantSwapModalError, { error: modalError, close: handleOnClose })),
            _a);
    };
    return {
        modalButtonMap: modalButtonMap,
        modalContentMap: modalContentMap,
        modalContent: modalContent
    };
}
